import React from 'react'

const OtrosInfo = () => {
    return (
        <div className="Info-table">
            <h2 className='title-info-others'>Agradecimientos </h2>
            <p className='description-info'>Esta sección está reservada para darles un <span className='mark-bold'>cordial agradecimiento</span> por visitar la página y consumir este contenido educativo. En el <span className='mark-bold underline'><a href="https://www.youtube.com/channel/UCaMiKcibLN6N04Cfogz8Pcw" target="_blank">canal de youtube</a></span> contamos con una serie de videos que pretenden bajar a tierra, de manera dinámica y entretenida los conceptos posracionalistas y, en la medida de lo posible, acercar al público hacia el descubrimiento de sí mismo.</p>
            <p className='description-info'>
                El posracionalismo tiene pocas décadas de historia si la comparamos con otras corrientes contemporáneas, sin embargo, este hecho lejos de restarle ímpetu y presencia fortalece sus cimientos bien construidos y extiende la seguridad que se desprende de sus bases bien pulidas.  
            </p>


        </div>
    )
}

export default OtrosInfo